module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/1f0a9c11d9fc93b24f2c0fed6cecf3ef.svg";


//////////////////
// WEBPACK FOOTER
// ./components/certificates/components/download-button/assets/download-icon.svg
// module id = w1s4
// module chunks = 1